// import components below
import PageHeaderUI from 'components/UI/PageHeaderUI';

// main component
const CreateTemporaryProfileHeader = () => {
  return (
    <div className='createTemporaryProfileHeader'>
      <PageHeaderUI>
        <h4>ACL Module</h4>
        <p>Dashboard / Profile / Edit Profile</p>
      </PageHeaderUI>
    </div>
  );
};

export default CreateTemporaryProfileHeader;
